/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowARightIcon24Solid = forwardRef('ArrowARightIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M13.002 5.186a1.5 1.5 0 0 1 2.121-2.122l6.284 6.284a3.75 3.75 0 0 1 0 5.304l-6.284 6.284a1.5 1.5 0 0 1-2.121-2.122l5.314-5.314H3a1.5 1.5 0 0 1 0-3h15.316l-5.314-5.314Z" })));
});
